import * as React from "react";
const SvgChevronUpIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 24, viewBox: "0 0 8 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 10L4.37114e-07 15L8 15L4 10Z", fill: "currentColor" }));
export default SvgChevronUpIcon;
